import { type ImagePickerAsset } from 'expo-image-picker'
import { createContext } from 'react'

import { PROFILE_PHOTOS_BUCKET, VERIFICATION_PHOTOS_BUCKET } from '@/lib'

type UploadedMedia = {
  id: string
  path: string
  fullPath: string
}

export interface MediaContextValue {
  isUploadingMedia: boolean
  getCameraMedia: () => Promise<ImagePickerAsset | null>
  getLibraryMedia: () => Promise<ImagePickerAsset | null>
  selectedAsset: ImagePickerAsset | null
  uploadMedia: (asset: ImagePickerAsset, bucket: MediaBuckets) => Promise<UploadedMedia | null>
}

export enum MediaBuckets {
  Profile = PROFILE_PHOTOS_BUCKET,
  Verification = VERIFICATION_PHOTOS_BUCKET
}

export const MediaContext = createContext<MediaContextValue>({
  isUploadingMedia: false,
  getCameraMedia: () => Promise.resolve(null),
  getLibraryMedia: () => Promise.resolve(null),
  selectedAsset: null,
  uploadMedia: () => Promise.resolve(null)
})
